// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * The following are shared across all platforms and apps
 */
.post-comments-lists {
  color: var(--undp-jtf-btn-dark-color);
}
.post-comments-lists .posts {
  clear: both;
  list-style: none;
  padding-left: 0;
  width: 100%;
  text-align: left;
}
.post-comments-lists .posts li {
  display: flex;
  background-color: #fff;
  border: 1.5px solid #d8d8d8;
  border-radius: 5px;
  padding-top: 10px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 10px;
  margin-bottom: 15px;
  word-wrap: break-word;
  min-height: 42px;
}
.post-comments-lists .posts li .trash-icon {
  margin-top: auto;
  margin-bottom: auto;
  margin-left: auto;
}
.post-comments-lists .posts li .trash-icon .fa {
  font-size: 20px;
  float: right;
  cursor: pointer;
}
.post-comments-lists .btn-more {
  color: var(--undp-jtf-btn-dark-color);
  margin-right: 10px;
}
.post-comments-lists .btn-more:focus {
  text-decoration: none;
  box-shadow: none;
}
.post-comments-lists .btn-less {
  color: var(--undp-jtf-btn-dark-color);
}
.post-comments-lists .btn-less:focus {
  text-decoration: none;
  box-shadow: none;
}`, "",{"version":3,"sources":["webpack://./libs/scss/_index.scss","webpack://./apps/hybrid-app/src/app/features/shared/post-viewers/post-comment-list/post-comment-list.component.scss"],"names":[],"mappings":"AAAA;;EAAA;ACCA;EACE,qCAAA;AAGF;AAFE;EACE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;AAIJ;AAFE;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;AAIJ;AAHI;EACE,gBAAA;EACA,mBAAA;EACA,iBAAA;AAKN;AAHM;EACE,eAAA;EACA,YAAA;EACA,eAAA;AAKR;AADE;EACE,qCAAA;EACA,kBAAA;AAGJ;AAFI;EACE,qBAAA;EACA,gBAAA;AAIN;AADE;EACE,qCAAA;AAGJ;AAFI;EACE,qBAAA;EACA,gBAAA;AAIN","sourcesContent":["/**\n * The following are shared across all platforms and apps\n */\n\n// shared variables\n@import 'variables';\n\n// create/import other scss files or define as needed...\n","@import '../../../../../scss/variables';\r\n.post-comments-lists {\r\n  color: var(--undp-jtf-btn-dark-color);\r\n  .posts {\r\n    clear: both;\r\n    list-style: none;\r\n    padding-left: 0;\r\n    width: 100%;\r\n    text-align: left;\r\n  }\r\n  .posts li {\r\n    display: flex;\r\n    background-color: #fff;\r\n    border: 1.5px solid #d8d8d8;\r\n    border-radius: 5px;\r\n    padding-top: 10px;\r\n    padding-left: 20px;\r\n    padding-right: 20px;\r\n    padding-bottom: 10px;\r\n    margin-bottom: 15px;\r\n    word-wrap: break-word;\r\n    min-height: 42px;\r\n    .trash-icon {\r\n      margin-top: auto;\r\n      margin-bottom: auto;\r\n      margin-left: auto;\r\n\r\n      .fa {\r\n        font-size: 20px;\r\n        float: right;\r\n        cursor: pointer;\r\n      }\r\n    }\r\n  }\r\n  .btn-more {\r\n    color: var(--undp-jtf-btn-dark-color);\r\n    margin-right: 10px;\r\n    &:focus {\r\n      text-decoration: none;\r\n      box-shadow: none;\r\n    }\r\n  }\r\n  .btn-less {\r\n    color: var(--undp-jtf-btn-dark-color);\r\n    &:focus {\r\n      text-decoration: none;\r\n      box-shadow: none;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
